/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The list of available security type :
 * * NONE : no security
 */
export enum OcppSecurity {
  NONE = 'NONE'
}
